/* eslint-disable-for-generated-file */
/**
 * Generated by orval
 * Do not edit manually.
 * Fireknife API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
    MutationFunction,
    QueryFunction,
    QueryKey,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query';

import type {
    APIErrorResponseResponse,
    ImporterBody,
    ImporterDiscover200,
    RequestStatusResponseResponse,
} from '.././model';

import { customInstance } from '.././custom-axios-instance';

/**
 * @summary Discover FareHarbor venue and items for import configuration
 */
export const importerDiscover = (slug: string, signal?: AbortSignal) => {
    return customInstance<ImporterDiscover200>({
        url: `/importer/${slug}/discover`,
        method: 'GET',
        signal,
    });
};

export const getImporterDiscoverQueryKey = (slug?: string) => {
    return [`/importer/${slug}/discover`] as const;
};

export const getImporterDiscoverQueryOptions = <
    TData = Awaited<ReturnType<typeof importerDiscover>>,
    TError = APIErrorResponseResponse,
>(
    slug: string,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof importerDiscover>>, TError, TData>;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getImporterDiscoverQueryKey(slug);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof importerDiscover>>> = ({ signal }) =>
        importerDiscover(slug, signal);

    return { queryKey, queryFn, enabled: !!slug, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof importerDiscover>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type ImporterDiscoverQueryResult = NonNullable<Awaited<ReturnType<typeof importerDiscover>>>;
export type ImporterDiscoverQueryError = APIErrorResponseResponse;

/**
 * @summary Discover FareHarbor venue and items for import configuration
 */

export function useImporterDiscover<
    TData = Awaited<ReturnType<typeof importerDiscover>>,
    TError = APIErrorResponseResponse,
>(
    slug: string,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof importerDiscover>>, TError, TData>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getImporterDiscoverQueryOptions(slug, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Import venue and shows from FareHarbor
 */
export const importer = (slug: string, importerBody: ImporterBody, signal?: AbortSignal) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/importer/${slug}`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: importerBody,
        signal,
    });
};

export const getImporterMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof importer>>,
        TError,
        { slug: string; data: ImporterBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof importer>>,
    TError,
    { slug: string; data: ImporterBody },
    TContext
> => {
    const mutationKey = ['importer'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof importer>>,
        { slug: string; data: ImporterBody }
    > = (props) => {
        const { slug, data } = props ?? {};

        return importer(slug, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type ImporterMutationResult = NonNullable<Awaited<ReturnType<typeof importer>>>;
export type ImporterMutationBody = ImporterBody;
export type ImporterMutationError = APIErrorResponseResponse;

/**
 * @summary Import venue and shows from FareHarbor
 */
export const useImporter = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof importer>>,
        TError,
        { slug: string; data: ImporterBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof importer>>,
    TError,
    { slug: string; data: ImporterBody },
    TContext
> => {
    const mutationOptions = getImporterMutationOptions(options);

    return useMutation(mutationOptions);
};
